import Vue from 'vue';

const filter = {
    formatNumberToThousandths(num) {
        // 将数字转换为字符串，并确保小数点后的部分也正确格式化
        return num.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        })
    },
}
Object.keys(filter).forEach((key) => {
    Vue.filter(key, filter[key]);
});

export default filter;
